import "@/App.css";
import "@/lib/pwa";
import "@/lib/i18n";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import SignInPage, { SignUpPage } from "@/pages/AuthPages";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Leads from "@/pages/admin/Leads";
import HeatMap from "@/pages/admin/HeatMap";
import Quotes from "@/pages/admin/Quotes";
import QuoteEditor from "@/pages/admin/QuoteEditor";
import Users from "@/pages/admin/Users";

// Il sito pubblico non dipende da Clerk: solo login e area admin sono dentro il provider
const AuthArea = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Legal doc="privacy" />} />
          <Route path="/termini" element={<Legal doc="termini" />} />
          <Route path="/cookie" element={<Legal doc="cookie" />} />
          <Route element={<AuthArea />}>
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="lead" element={<Leads />} />
              <Route path="mappa" element={<HeatMap />} />
              <Route path="preventivi" element={<Quotes />} />
              <Route path="preventivi/nuovo" element={<QuoteEditor />} />
              <Route path="preventivi/:id" element={<QuoteEditor />} />
              <Route path="utenti" element={<Users />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
